import React, { useEffect, useState } from "react";
import { CategoryService } from "../../../services/user/category.services";
import { ItemsService } from "../../../services/user/items.services";

const MainItemDetailsModal = ({ showMainItemModal, setShowMainItemModal, handleMainItemSelect }) => {
    const [categoryDetails, setCategoryDetails] = useState({
        categoryId: "",
        categoryName: "",
        mainItem: null,
    });
    const [categories, setCategories] = useState([]);   
    const [filteredItems, setFilteredItems] = useState([]);

    const handleCategoryChange = async (e) => {
        const selectedCategoryName = e.target.value;
        setCategoryDetails((prev) => ({
            ...prev,
            categoryName: selectedCategoryName,
            mainItem: null,
        }));

        const selectedCategory = categories.find(
            (category) => category.categoryName === selectedCategoryName
        );
        if (selectedCategory) {
            setCategoryDetails((prev) => ({
                ...prev,
                categoryId: selectedCategory.categoryId,
            }));

            const itemsByCategory = await ItemsService.getItemsByCategoryId(selectedCategory.categoryId);
            setFilteredItems(itemsByCategory);

            if(itemsByCategory.length > 0){
                setCategoryDetails((prev) => ({
                    ...prev,
                    mainItem: itemsByCategory[0],
                }));
            }
        }
    };

    const handleItemSelect = (e, item) => {
        const { checked } = e.target;
        if (checked) {
            setCategoryDetails((prev) => ({
                ...prev,
                mainItem: item,
            }));
        }
        else {
            setCategoryDetails((prev) => ({
                ...prev,
                mainItem: null,
            }));
        }
    };

    const handleSubmit = () => {
        handleMainItemSelect([categoryDetails.mainItem]);
        setShowMainItemModal(false);
    };

    useEffect(() => {
        const fetchCategory = async () => {
            const response = await CategoryService.getAllCategory();
            setCategories(response);
            if (response.length > 0) {
                setCategoryDetails({
                    categoryId: response[0].categoryId,
                    categoryName: response[0].categoryName,
                    mainItem: null
                });

                const itemsByCategory = await ItemsService.getItemsByCategoryId(response[0].categoryId);
                setFilteredItems(itemsByCategory);

                if(itemsByCategory.length > 0){
                    setCategoryDetails((prev) => ({
                        ...prev,
                        mainItem: itemsByCategory[0],
                    }));
                }
            }
        };

        fetchCategory();
    }, []);

    const getImageFromBuffer = (buffer) => {
        if (buffer?.data) {
            const blob = new Blob([new Uint8Array(buffer.data)], { type: 'image/jpeg' });
            return URL.createObjectURL(blob);
        }
        return '';
    };

    return (
        <>
            {showMainItemModal && (
                <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content shadow-lg rounded">
                            <div className="modal-header bg-primary text-white">
                                <h5 className="modal-title">Main Items</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowMainItemModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    {/* Category Type Dropdown */}
                                    <div className="mb-4">
                                        <label className="form-label d-flex">Category Type</label>
                                        <select
                                            className="form-select"
                                            value={categoryDetails.categoryName}
                                            onChange={handleCategoryChange}
                                        >
                                            <option value="">Select Category Type</option>
                                            {categories.map((category) => (
                                                <option
                                                    key={category.categoryId}
                                                    value={category.categoryName}
                                                >
                                                    {category.categoryName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Table for Items */}
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Image</th>
                                                    <th>Select</th>
                                                    <th>Item ID</th>
                                                    <th>Item Name</th>
                                                    <th>Price</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredItems.length > 0 ? (
                                                    filteredItems.map((item) => (
                                                        <tr key={item.itemId}>
                                                            <td>
                                                                <img
                                                                    src={getImageFromBuffer(item.itemImage)}
                                                                    alt={item.itemName}
                                                                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={categoryDetails.mainItem?.itemId === item.itemId}
                                                                    onChange={(e) => handleItemSelect(e, item)}
                                                                />
                                                            </td>
                                                            <td>{item.itemId}</td>
                                                            <td>{item.itemName}</td>
                                                            <td>{item.price}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            No items available for the selected category.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowMainItemModal(false)}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default MainItemDetailsModal;
